import Logo from "@/components/Logo";
import { Link } from "react-router-dom";
import { Mail, Shield, FileText } from "lucide-react";

export default function Footer() {
    return (
        <footer className="dark-section mt-32" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2" data-testid="footer-brand">
                    <div className="flex items-center gap-4">
                        <Logo onDark size={52} withText={false} />
                        <span className="self-stretch w-px" style={{ background: "linear-gradient(180deg, transparent, rgba(229,198,121,0.7), transparent)" }} />
                        <div className="leading-none">
                            <div className="font-display text-3xl tracking-tight" style={{ color: "var(--text-on-dark)" }}>Savoir Utile</div>
                            <div className="mt-2 text-[9px] sm:text-[10px] font-semibold tracking-[0.16em] sm:tracking-[0.28em] whitespace-nowrap" style={{ color: "var(--gold-300)" }}>APPRENDRE · COMPRENDRE · PRATIQUER</div>
                        </div>
                    </div>
                    <p className="mt-6 text-sm leading-relaxed max-w-md" style={{ color: "var(--text-on-dark-soft)" }} data-testid="footer-tagline">
                        <strong className="font-semibold" style={{ color: "var(--gold-300)" }}>La science religieuse à la portée de tous.</strong>{" "}
                        Découvrez des cours structurés, des ouvrages, des audios et des ressources soigneusement vérifiées, pour apprendre à votre rythme et acquérir un savoir authentique, bénéfique et applicable au quotidien.
                    </p>
                    <div className="mt-6 flex items-center gap-3" aria-hidden="true">
                        <span className="h-px w-12" style={{ background: "linear-gradient(90deg, transparent, var(--gold-300))" }} />
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--gold-300)" strokeWidth="1.3"><path d="M12 2l2.6 3.7L19 4.9l-.8 4.5L22 12l-3.8 2.6.8 4.5-4.4-.8L12 22l-2.6-3.7-4.4.8.8-4.5L2 12l3.8-2.6L5 4.9l4.4.8z" /></svg>
                        <span className="h-px w-24" style={{ background: "linear-gradient(90deg, var(--gold-300), transparent)" }} />
                    </div>
                </div>
                <div>
                    <div className="text-xs font-semibold tracking-[0.22em] uppercase mb-5" style={{ color: "var(--gold-300)" }}>
                        Plateforme
                    </div>
                    <ul className="space-y-3 text-sm" style={{ color: "var(--text-on-dark-soft)" }}>
                        <li><Link to="/" className="hover:text-[#E5C679] transition-colors">Accueil</Link></li>
                        <li><Link to="/catalogue" className="hover:text-[#E5C679] transition-colors">Catalogue</Link></li>
                        <li><Link to="/a-propos" className="hover:text-[#E5C679] transition-colors">À propos</Link></li>
                        <li><Link to="/rappel" className="hover:text-[#E5C679] transition-colors">Rappel du jour</Link></li>
                        <li><Link to="/contact" className="hover:text-[#E5C679] transition-colors">Contact</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs font-semibold tracking-[0.22em] uppercase mb-5" style={{ color: "var(--gold-300)" }}>
                        Légal
                    </div>
                    <ul className="space-y-3 text-sm" style={{ color: "var(--text-on-dark-soft)" }}>
                        <li><Link to="/conditions" className="hover:text-[#E5C679] transition-colors" data-testid="footer-terms">Conditions d'utilisation</Link></li>
                        <li><Link to="/confidentialite" className="hover:text-[#E5C679] transition-colors" data-testid="footer-privacy">Confidentialité</Link></li>
                        <li><Link to="/contact" className="hover:text-[#E5C679] transition-colors" data-testid="footer-contact">Contact</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t" style={{ borderColor: "var(--border-dark)" }}>
                <div
                    className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs flex flex-col sm:flex-row items-center justify-between gap-3"
                    style={{ color: "rgba(244,238,223,0.45)" }}
                >
                    <div>© {new Date().getFullYear()} Savoir Utile. Tous droits réservés.</div>
                    <div className="font-mono flex items-center gap-4">
                        <span className="inline-flex items-center gap-1.5"><Shield className="w-3 h-3" /> Paiement Stripe</span>
                        <span className="inline-flex items-center gap-1.5"><FileText className="w-3 h-3" /> stockage chiffré</span>
                        <span className="inline-flex items-center gap-1.5"><Mail className="w-3 h-3" /> support@savoirutile.com</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
